import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Select as AntSelect, Switch } from "antd";
import { useTranslation } from "react-i18next";
import {
  getSettingPreferences,
  updateSettingPreference,
} from "../../services/orgService";
import { toastMessage } from "../../helper";
import { ORG_REDUCER } from "../../constants/enums";

const Security = () => {
  const { Option } = AntSelect;
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [settingsData, setSettingsData] = useState<any>();
  const [emailAuthEnabled, setEmailAuthEnabled] = useState<boolean>(false);
  const [appAuthEnabled, setAppAuthEnabled] = useState<boolean>(false);

  useEffect(() => {
    getSettingPreferences(false).then((res) => {
      setSettingsData(res.data);
      res.data.email_auth_enabled && setEmailAuthEnabled(true);
      res.data.app_auth_enabled && setAppAuthEnabled(true);
    });
  }, []);

  const handleAuthSettings = (type: string, enabled: boolean) => {
    type === "email" && enabled && appAuthEnabled && setAppAuthEnabled(false);
    type === "app" && enabled && emailAuthEnabled && setEmailAuthEnabled(false);
    type === "email"
      ? setEmailAuthEnabled(enabled)
      : setAppAuthEnabled(enabled);
  };

  const handleSettingsSave = () => {
    const reqData = {
      id: settingsData.id,
      emailAuthEnabled,
      appAuthEnabled,
    };
    updateSettingPreference(reqData).then((res: any) => {
      res?.data &&
        dispatch({
          type: ORG_REDUCER.SET_COMPANY_PREFERENCES,
          payload: res.data,
        });
      toastMessage("Data updated successfully", "success");
    });
  };

  return (
    <Fragment>
      <div
        style={{ height: "100%", position: "relative" }}
        className="pw-settings-main h-100v w-full flex flex-col"
      >
        <div className="pw-all-fileds-settings w-full">
          <div className="pw-company-name flex flex-col gap-y-1 mt-2">
            <div className="pw-text-neutral-600 pw-font-14px">
              {"Two-factor authentication"}
            </div>
            <div className="pw-font-12px">
              {
                "Two-factor authentication adds an additional layer of security to your account by requiring more than just a password to sign in."
              }
            </div>
            <div className="flex flex-row items-center gap-x-2 mt-2">
              <Switch
                style={{ color: "green" }}
                checked={emailAuthEnabled}
                onChange={(e) => handleAuthSettings("email", e)}
                size="small"
              />
              <div className="text-sm text-neutral-900">
                Email-based One Time Password (OTP)
              </div>
            </div>
            <div className="flex flex-row items-center gap-x-2 mt-2">
              <Switch
                style={{ color: "green" }}
                checked={appAuthEnabled}
                onChange={(e) => handleAuthSettings("app", e)}
                size="small"
              />
              <div className="text-sm text-neutral-900">
                Authenticator app for Time-based One Time Password (TOTP)
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ position: "absolute", bottom: "0", left: "0" }}
          className="flex flex-row justify-end w-full pw-bunit-footer gap-6"
        >
          <button
            className={`pw-bunit-button-primary pw-bunit-button-next text-white font-bold cursor-pointer bg-primary`}
            onClick={() => handleSettingsSave()}
          >
            {"Save"}
          </button>
        </div>
      </div>
    </Fragment>
  );
};
export default Security;
